(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    // Expose globally so inline onclick handlers can find it
  window.shareArticle = function () {
    const articleUrl = window.location.href;
    const titleEl = document.querySelector('.article-title-share-title');
    const articleTitle = titleEl ? titleEl.textContent : document.title;

    if (navigator.share) {
      navigator
        .share({
          title: articleTitle,
          url: articleUrl,
        })
        .catch(function () {
          window.fallbackShareArticle(articleUrl);
        });
    } else {
      window.fallbackShareArticle(articleUrl);
    }
  };

  window.fallbackShareArticle = function (url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(function () {
          alert('Article link copied to clipboard!');
        })
        .catch(function () {
          window.promptShareArticle(url);
        });
    } else {
      window.promptShareArticle(url);
    }
  };

  window.promptShareArticle = function (url) {
    const input = document.createElement('input');
    input.value = url;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    alert('Article link copied to clipboard!');
  };
  } catch(e) { console.error(e); }
})();

})();
